import * as React from "react"
import { MdExpandMore } from "react-icons/md"

// Using HeaderNavItem would require a ton of refactoring
// This isn't the ideal implementation, but it works,
// is self-contained, and is decoupled from global nav

const links = [
  {
    text: `v4 Docs`,
    url: `https://v4.gatsbyjs.com/docs/`,
  },
  {
    text: `v3 Docs`,
    url: `https://v3.gatsbyjs.com/docs/`,
  },
  {
    text: `v2 Docs`,
    url: `https://v2.gatsbyjs.com/docs/`,
  },
  {
    text: `v1 Docs`,
    url: `https://v1.gatsbyjs.org/docs/`,
  },
]

export default function DocsVersionDropdown() {
  const [open, setOpen] = React.useState(false)
  const rootRef = React.useRef(null)

  const handleBodyClick = e => {
    if (rootRef?.current.contains(e.target)) return
    setOpen(false)
  }

  React.useEffect(() => {
    document.body.addEventListener("click", handleBodyClick)
    return () => {
      document.body.removeEventListener("click", handleBodyClick)
    }
  }, [])

  return (
    <div
      ref={rootRef}
      css={{
        position: "relative",
      }}
    >
      <button
        onClick={() => {
          setOpen(!open)
        }}
        css={theme => ({
          // mobile
          display: "none",
          // desktop
          [theme.mediaQueries.desktop]: {
            appearance: "none",
            display: "flex",
            alignItems: "center",
            fontFamily: "inherit",
            fontSize: theme.fontSizes[1],
            color: "inherit",
            backgroundColor: "transparent",
            border: 0,
            margin: 0,
            paddingTop: theme.space[3],
            paddingBottom: theme.space[3],
            paddingLeft: theme.space[4],
            paddingRight: theme.space[4],
            cursor: "pointer",
            "&:hover, &:focus": {
              backgroundColor: theme.colors.purple[1],
            },
          },
        })}
      >
        v5
        <MdExpandMore />
      </button>
      <hr
        css={theme => ({
          marginBottom: theme.space[2],
          [theme.mediaQueries.desktop]: {
            display: "none",
          },
        })}
      />
      <div
        css={theme => ({
          display: "block",
          [theme.mediaQueries.desktop]: {
            position: "absolute",
            top: "100%",
            left: "50%",
            transform: "translateX(-50%)",
            display: open ? "block" : "none",
            paddingTop: theme.space[3],
            paddingBottom: theme.space[3],
            backgroundColor: theme.colors.white,
            borderRadius: theme.radii[3],
            boxShadow: theme.shadows.dialog,
            overflow: "hidden",
          },
        })}
      >
        {links.map(link => (
          <a
            key={link.url}
            target="_blank"
            href={link.url}
            css={theme => ({
              display: "block",
              fontSize: theme.fontSizes[1],
              paddingTop: theme.space[2],
              paddingBottom: theme.space[2],
              paddingLeft: theme.space[3],
              paddingRight: theme.space[3],
              color: "inherit",
              textDecoration: "none",
              "&:hover, &:focus": {
                textDecoration: "underline",
              },
              [theme.mediaQueries.desktop]: {
                minWidth: 96,
                textAlign: "center",
              },
            })}
            rel="noreferrer"
          >
            {link.text}
          </a>
        ))}
      </div>
    </div>
  )
}
